export default "__VITE_ASSET__DR6jgVZn__"